'use es6';

import Log from 'forms-utils-lib/logger/Logger';
import getLegalConsentCopy from 'forms-utils-lib/api/legalConsent/getLegalConsentCopy';
import { LegalConsentOptions, LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
import { scrollMainPanel } from 'FormsUI/utils/AnimationUtils';
import { getFormsLangToLegalConsentLang } from 'FormsUI/utils/Lang';
import { getFormLanguage } from 'FormsUI/selectors/FormDefinition';
import { getCurrentFormBusinessUnitId } from 'FormsUI/selectors/Editor';
import { updateMetaData } from 'FormsUI/actions/FormDefinition';
import updateLegalConsentOptionFromApi from './updateLegalConsentOptionFromApi';
import { removeLegalConsentErrors } from 'FormsUI/actions/FormDefinition';
export const updateLegalConsentOption = legalConsentOption => (dispatch, getState) => {
  const state = getState();
  const formLanguage = getFormLanguage(state);
  const businessUnitId = getCurrentFormBusinessUnitId(state);
  const settingsLang = getFormsLangToLegalConsentLang(formLanguage);
  if (legalConsentOption === LegalConsentOptions.NONE) {
    return dispatch(updateMetaData(LEGAL_CONSENT_OPTIONS_KEY, null));
  }
  scrollMainPanel('[data-test-id="legal-consent-container"]');
  dispatch(removeLegalConsentErrors());
  return getLegalConsentCopy({
    language: settingsLang,
    businessUnitId
  }).then(legalConsentCopy => {
    dispatch(updateLegalConsentOptionFromApi(legalConsentOption, legalConsentCopy));
  }).catch(e => {
    Log.logServiceError('Failed to update legal consent option', e);
  });
};
export default updateLegalConsentOption;